import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountingEntryRule.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.accountingEntryRule.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.accountingEntryRule.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.accountingEntryRule.remove,
    method: 'post',
    data: requestBody
  })
}
